/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryResponse,
  GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryParams,
  GetApiV1CourseregistrationEnrollmentBatchStatusGrid401,
  GetApiV1CourseregistrationEnrollmentBatchStatusGrid500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentBatchStatusGrid.ts";

function getGetApiV1CourseregistrationEnrollmentBatchStatusGridUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/enrollment/batch-status-grid` as const,
  };
  return res;
}

/**
 * @description Retorna paginado os alunos de uma turma que podem ter seu status de matrícula alterado para o status destino informado. Aplica as regras de elegibilidade por par de status (origem → destino) e enriquece cada registro com notas médias, frequência, nota do exame final e nota de defesa de monografia. Opcionalmente filtra por status de bolsa. Retorna lista vazia quando classStudentId ou enrollmentStatus não são informados. **(Requer Authorization para autenticação)**
 * @summary Lista alunos elegíveis para alteração de status em lote (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/batch-status-grid}
 */
export async function getApiV1CourseregistrationEnrollmentBatchStatusGrid(
  params?: GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationEnrollmentBatchStatusGridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentBatchStatusGrid401
      | GetApiV1CourseregistrationEnrollmentBatchStatusGrid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationEnrollmentBatchStatusGridUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
